module.exports = {"markup":"<span class=\"inline-arrow-down inline-icon\"><svg width=\"24\" height=\"18\" viewBox=\"-0.525 -4 24 18\" overflow=\"visible\" enable-background=\"new -0.525 -4 24 18\"><path d=\"M23.2.7L12.7 9.1l-1.1.9-1.1-.898L0 .7.5 0l11.1 6.3L22.7 0l.5.7z\"/></svg></span>"}


//////////////////
// WEBPACK FOOTER
// ./dev/webpack-loaders/svg-loader!./static/src/inline-svgs/icon/arrow-down.svg
// module id = 249
// module chunks = 0 1 16